<template>
	<div class="flex flex-col">
		<div class="flex flex-col-reverse md:flex-col">
			<span class="text-sm md:text-base mb-6 md:mb-1 text-dj-gray-dark md:hidden">
				{{ location }}
			</span>
			<span class="text-sm md:text-base mb-6 md:mb-1 text-dj-gray-dark">
				{{ motto }}
			</span>
			<h1 class="font-medium text-xl md:text-4xl md:leading-10 md:mb-4">
				{{ name }}
			</h1>
		</div>
		<div class="text-sm md:text-base text-dj-gray-dark flex flex-wrap max-w-[350px] sm:max-w-full gap-y-2">
			<span class="block" v-for="(tag, index) in tags" :key="index">
				{{ tag[locale] }}
				<span v-if="index != tags.length - 1" class="mx-2">|</span>
			</span>
			<template v-for="(badge, index) in companyBadges" :key="index">
				<BaseTagPill v-if="badge.slug == 'startup-ceg-vagyunk'" type="red" size="normal" class="ml-4 -mt-2">
					startup
				</BaseTagPill>
			</template>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "CompanyProfileInfo",
	props: {
		motto: {
			type: String,
			default: "Company's motto",
		},
		name: {
			type: String,
			default: "Company name",
		},
		tags: {
			type: Array,
		},
		location: {
			type: String,
			default: "company address",
		},
		companyBadges: {
			type: Array,
		},
	},
	setup(_props) {
		const { locale } = useI18n();

		return {
			locale,
		};
	},
});
</script>
